export const DELIVERY_DATE_FORMAT = 'EEEE, MMMM do yyyy';
export const ORDER_API_DATE_FORMAT = "yyyyy-MM-dd'T'HH:mm:ssxxxx";
export const DEFAULT_HOURS = 12;

export function getCurrentDate() {
    const currentDate = new Date();

    return new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), DEFAULT_HOURS, 0, 0, 0));
}

export function shouldClearTimeSelectors(years: number | null, months: number | null): boolean {
    return years === 0 && months === 0;
}